<script>
import { CdrContainer } from '@rei/cedar';
import convertToHtml from '@rei/rich-text-renderer';
import fetchData from '../../utils/api';
import analyticsMixin from '../../common/mixins/analyticsMixin';

export default {
  name: 'ArticlePageComponent',
  components: {
    CdrContainer,
  },
  mixins: [analyticsMixin],
  props: {
    heading: { type: String, default: '' },
    sections: { type: Array, default: () => [] },
    description: { type: String, default: '' },
    url: { type: String, default: '' },
  },
  data() {
    return {
      livePreviewHash: '',
      content: {
        heading: this.heading,
        sections: this.sections,
        description: this.description,
      },
    };
  },
  mounted() {
    // Register for Live Preview Update Events
    window.addEventListener('OnLivePreviewUpdate', (event) => {
      console.log('OnLivePreviewUpdate triggered', event);
      const hash = event?.detail?.hash;
      if (hash) fetchData(`${this.url}/preview?hash=${hash}`, this.updateData);
    });
  },
  methods: {
    updateData(data) {
      this.content = data;
    },
    convertToHtml,
  },
};
</script>
<template>
  <cdr-container>
    <article class="article">
      <h1
        v-if="content?.heading"
        class="article__heading"
        data-ui="article-heading"
      >
        {{ content.heading }}
      </h1>
      <p
        v-if="content?.description"
        class="article__description"
        data-ui="article-description"
      >
        {{ content.description }}
      </p>
      <section
        v-for="(section, index) in content?.sections"
        :key="index"
        data-ui="article-section"
      >
        <h2
          class="article__section-heading"
          data-ui="section-heading"
        >
          {{ section.heading }}
        </h2>
        <div
          data-ui="section-body"
          class="article__section-body"
          v-html="convertToHtml(section.body)"
        />
      </section>
    </article>
  </cdr-container>
</template>
<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';
  .article {
    max-width: 1200px;
    margin-top: $cdr-space-one-and-a-half-x;
    &__heading {
      @include cdr-text-heading-serif-800;
    }
    &__section-heading {
      @include cdr-text-heading-serif-600;
    }
    &__section-body h3 {
      @include cdr-text-body-strong-300;
    }
  }
</style>
